export default __webpack_public_path__ + "static/media/details4.08f9829c.jpg";